/* WHITE GLOVE UPGRADE (DMV 2026-10-10, R-113). The cart checkbox adds the unlisted "White Glove Delivery" item once per
   order and removes it when unticked. Loaded with the cart scripts (not inside the snippet) because the theme redraws
   the cart summary with innerHTML, and scripts inside redrawn HTML never run. */
if (!customElements.get('white-glove-upgrade')) {
  class WhiteGloveUpgrade extends HTMLElement {
    connectedCallback() {
      this.check = this.querySelector('.dmv-wg__check');
      this.err = this.querySelector('.dmv-wg__err');
      if (!this.check || this.bound) return;
      this.bound = true;
      this.check.addEventListener('change', () => this.toggle(this.check.checked));
      const qty = Number(this.dataset.qty || 0);
      const furniture = Number(this.dataset.furniture || 0);
      if (qty > 0 && furniture === 0) this.toggle(false);   // nothing left to deliver: take the upgrade off
      else if (qty > 1) this.setQty(1).then(() => this.refresh()).catch(() => {});   // once per order
    }

    async post(path, body) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error(String(res.status));
      return res.json();
    }

    setQty(quantity) {
      return this.post('cart/change.js', { id: String(this.dataset.variantId), quantity: quantity });
    }

    async toggle(on) {
      this.check.disabled = true;
      if (this.err) this.err.hidden = true;
      try {
        if (on) await this.post('cart/add.js', { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] });
        else await this.setQty(0);
        this.refresh();
      } catch (e) {
        this.check.checked = !on;
        this.check.disabled = false;
        if (this.err) { this.err.textContent = 'Something went wrong. Please try again.'; this.err.hidden = false; }
      }
    }

    refresh() {
      if (this.closest('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        return;
      }
      const items = document.querySelector('cart-items');
      if (items && typeof items.refresh === 'function') items.refresh();
      else window.location.reload();
    }
  }
  customElements.define('white-glove-upgrade', WhiteGloveUpgrade);
}
